module.exports = __webpack_public_path__ + "assets/img/licenseIcon.b94dd286.svg";